import moment from 'moment-timezone';

/*
 * Period presets — the shared time-range vocabulary. The old pill
 * component retired 2026-08-14 (the filter pill's Date dimension is the
 * date control now); the groups and range math live on for the
 * DateRangeDrill in FilterMenu.
 */

export type PeriodKey =
    | 'today'
    | 'tomorrow'
    | 'this_week'
    | 'this_month'
    | 'this_year'
    | 'next_7'
    | 'next_30'
    | 'next_6m'
    | 'next_12m'
    | 'all_time';

export const PERIOD_GROUPS: { key: PeriodKey; label: string }[][] = [
    [
        { key: 'today', label: 'Today' },
        { key: 'tomorrow', label: 'Tomorrow' },
        { key: 'this_week', label: 'This week' },
        { key: 'this_month', label: 'This month' },
        { key: 'this_year', label: 'This year' },
    ],
    [
        { key: 'next_7', label: 'Next 7 days' },
        { key: 'next_30', label: 'Next 30 days' },
        { key: 'next_6m', label: 'Next 6 months' },
        { key: 'next_12m', label: 'Next 12 months' },
    ],
    [{ key: 'all_time', label: 'All time' }],
];

export function periodRange(
    key: PeriodKey,
): [moment.Moment, moment.Moment] | null {
    const now = moment();
    switch (key) {
        case 'today':
            return [now.clone().startOf('day'), now.clone().endOf('day')];
        case 'tomorrow':
            return [
                now.clone().add(1, 'day').startOf('day'),
                now.clone().add(1, 'day').endOf('day'),
            ];
        case 'this_week':
            return [now.clone().startOf('week'), now.clone().endOf('week')];
        case 'this_month':
            return [now.clone().startOf('month'), now.clone().endOf('month')];
        case 'this_year':
            return [now.clone().startOf('year'), now.clone().endOf('year')];
        case 'next_7':
            return [
                now.clone().startOf('day'),
                now.clone().add(6, 'days').endOf('day'),
            ];
        case 'next_30':
            return [
                now.clone().startOf('day'),
                now.clone().add(29, 'days').endOf('day'),
            ];
        case 'next_6m':
            return [
                now.clone().startOf('day'),
                now.clone().add(6, 'months').endOf('day'),
            ];
        case 'next_12m':
            return [
                now.clone().startOf('day'),
                now.clone().add(12, 'months').endOf('day'),
            ];
        default:
            return null;
    }
}

